import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const CustomizedComponent = styled(Box)(({ theme }) => ({
  overflowY: "auto",
  margin: 0,
  minHeight: "300px",
}));

const OmniDialogTab = props => {
  const { children, selectedIndex, index, ...other } = props;
  return (
    <CustomizedComponent role="DialogTab" hidden={selectedIndex !== index} {...other}>
      {children}
    </CustomizedComponent>
  );
};

export default OmniDialogTab;
